import {
    FETCH_TID_REQUEST,
    FETCH_TID_SUCCESS,
    FETCH_TID_ERROR,
    GET_MERCHANT_INFO_ERROR,
    GET_MERCHANT_INFO_SUCCESS,
    CREATE_TID_REQUEST,
    GET_TERMINAL_INFO_REQUEST,
    GET_TERMINAL_INFO_ERROR,
    GET_TERMINAL_INFO_SUCCESS,
    FETCH_ENTITY_HIERARCHY_REQUEST,
    FETCH_ENTITY_HIERARCHY_SUCCESS,
    FETCH_ENTITY_HIERARCHY_ERROR,
    RESET_TERMINAL_DATA,
    FETCH_STATIC_URL,
    FETCH_STATIC_URL_ERROR,
    FETCH_STATIC_URL_SUCCESS,
    RESET_MERCHANT_DATA,
    RESET_H_LIST,
    GET_MERCHANT_INFO_REQUEST,
    FETCH_ENTITY_LIST_MERCHANT_ERROR,
    FETCH_ENTITY_LIST_MERCHANT_REQUEST,
    FETCH_ENTITY_LIST_MERCHANT_SUCCESS,
    SHOW_ENTITY_HIERARCHY_LOADER,
    HIDE_ENTITY_HIERARCHY_LOADER,
    FETCH_ENTITY_LIST_MERCHANT_SUCCESS_ADD_LIST,
    TERMINAL_ID_BULK_UPLOAD_REQUEST,
} from './TIDOnBoard.constants';

export const terminalIDBulkUploadRequest = (
    payload,
    handleSuccess,
    handleError
) => ({
    type: TERMINAL_ID_BULK_UPLOAD_REQUEST,
    payload,
    handleSuccess,
    handleError,
});

export const fetchTIDRequest = payload => ({
    type: FETCH_TID_REQUEST,
    payload,
});

export const fetchTIDSuccess = payload => ({
    type: FETCH_TID_SUCCESS,
    payload,
});

export const fetchTIDError = payload => ({
    type: FETCH_TID_ERROR,
    payload,
});

export const getMerchantInfoRequest = (payload, fields, history, toast) => ({
    type: GET_MERCHANT_INFO_REQUEST,
    payload,
    fields,
    history,
    toast,
});

export const addTIDMakerRequest = (payload, history, toast, makerId) => ({
    type: CREATE_TID_REQUEST,
    payload,
    history,
    toast,
    makerId,
});

export const getMerchantInfoSuccess = payload => ({
    type: GET_MERCHANT_INFO_SUCCESS,
    payload,
});

export const getMerchantInfoError = (payload, history, toast) => ({
    type: GET_MERCHANT_INFO_ERROR,
    payload,
    history,
    toast,
});

export const getTerminalInfoRequest = (payload, history, toast) => ({
    type: GET_TERMINAL_INFO_REQUEST,
    payload,
    history,
    toast,
});

export const getTerminalInfoSuccess = payload => ({
    type: GET_TERMINAL_INFO_SUCCESS,
    payload,
});

export const getTerminalInfoError = (payload, history, toast) => ({
    type: GET_TERMINAL_INFO_ERROR,
    payload,
    history,
    toast,
});

export const fetchEntityHierarchyRequest = (payload, entityType) => ({
    type: FETCH_ENTITY_HIERARCHY_REQUEST,
    payload,
    entityType,
});

export const fetchEntityHierarchySuccess = payload => ({
    type: FETCH_ENTITY_HIERARCHY_SUCCESS,
    payload,
});

export const fetchEntityHierarchyError = payload => ({
    type: FETCH_ENTITY_HIERARCHY_ERROR,
    payload,
});

export const resetTerminalData = () => ({
    type: RESET_TERMINAL_DATA,
});

export const fetchStaticURL = payload => ({
    type: FETCH_STATIC_URL,
    payload,
});

export const fetchStaticUrlSuccess = payload => ({
    type: FETCH_STATIC_URL_SUCCESS,
    payload,
});

export const fetchStaticUrlError = payload => ({
    type: FETCH_STATIC_URL_ERROR,
    payload,
});

export const resetMerchantData = payload => ({
    type: RESET_MERCHANT_DATA,
});

export const resetHList = payload => ({
    type: RESET_H_LIST,
});

export const fetchEntityListRequest = (payload, entityData) => ({
    type: FETCH_ENTITY_LIST_MERCHANT_REQUEST,
    payload,
    entityData,
});

export const fetchEntityListSuccess = payload => ({
    type: FETCH_ENTITY_LIST_MERCHANT_SUCCESS,
    payload,
});

export const fetchEntityListError = payload => ({
    type: FETCH_ENTITY_LIST_MERCHANT_ERROR,
    payload,
});

export const showHierarchyLoader = () => ({
    type: SHOW_ENTITY_HIERARCHY_LOADER,
});
export const hideHierarchyLoader = () => ({
    type: HIDE_ENTITY_HIERARCHY_LOADER,
});

export const fetchEntityListSuccessAddList = (payload, entityType) => ({
    type: FETCH_ENTITY_LIST_MERCHANT_SUCCESS_ADD_LIST,
    payload,
    entityType,
});
